import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { BaseService } from 'src/app/core/services/base.service';

@Injectable({
    providedIn: 'root',
})
export class SharedLatestVideosService extends BaseService {
    constructor(private http: HttpClient) {
        super();
    }

    /**
     * getLastVideos() - Buscar últimos 3 videos
     *
     */
    getLastVideos(departmentType): Observable<any> {
        // Instacia o body através de BaseService.setBody();
        let body = this.setBody();

        // departmentType: Filtra vídeos por departamento
        body.set('departmentType', departmentType);
        // limit: Definir o retorno máximo de últimos vídeos
        body.set('limit', '3');
        // publishHome: Buscar somente videos para a home
        body.set('publishHome', '0');

        let response = this.http
            .post(this.urlService + this.routeAdress.route_news_videos, body.toString())
            .pipe(map(this.extractData), catchError(this.serviceError));

        return response;
    }
}
